module.exports = __webpack_public_path__ + "assets/35e6d4cdb0f3706259ff0880513e90b8.jpg";